export default __webpack_public_path__ + "static/media/learning_app_login.0d08f3c1.png";